import { http } from "../_apiConfig/http";
import { ApiRoutes } from "../routes/apiRoutes";

export const SiteService = {
  createSite,
  updateSite,
  getSiteList,
  getSingleSite,
  deleteSite,
  getSitesByOrganization,
};

// CREATE SITE
function createSite(data) {
  return http.post(`${ApiRoutes.Site}`, data, true);
}

// UPDATE SITE
function updateSite(siteId, data) {
  return http.update(`${ApiRoutes.Site}/${siteId}`, data, true);
}

// GET ALL SITES
function getSiteList(queryParams = "") {
  return http.get(`${ApiRoutes.Site}${queryParams}`, true);
}

// GET SINGLE SITE DETAILS
function getSingleSite(siteId) {
  return http.get(`${ApiRoutes.Site}/${siteId}`, true);
}

// DELETE SITE
function deleteSite(siteId) {
  return http.remove(`${ApiRoutes.Site}/${siteId}`, true);
}

// GET ALL SITES BY ORGANIZATION
function getSitesByOrganization(
  organization_id,
  params = { page: 1, limit: 20 }
) {
  return http.get(
    `${ApiRoutes.Site}/organization/${organization_id}`,
    { params },
    true
  );
}


